/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  BulkSetPartnersDto,
  CreateFeatureFlagDto,
  FeatureFlagDetailDto,
  FeatureFlagListItemDto,
  FeatureFlagPartnerStatusDto,
  FeatureFlagsControllerGetFlagsParams,
  FeatureFlagsResponseDto,
  UpdateFeatureFlagDto
} from '../schemas';

import { customFetch } from '../../custom-fetch.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type featureFlagsControllerGetFlagsResponse200 = {
  data: FeatureFlagsResponseDto
  status: 200
}

export type featureFlagsControllerGetFlagsResponse401 = {
  data: void
  status: 401
}

export type featureFlagsControllerGetFlagsResponseSuccess = (featureFlagsControllerGetFlagsResponse200) & {
  headers: Headers;
};
export type featureFlagsControllerGetFlagsResponseError = (featureFlagsControllerGetFlagsResponse401) & {
  headers: Headers;
};

export type featureFlagsControllerGetFlagsResponse = (featureFlagsControllerGetFlagsResponseSuccess | featureFlagsControllerGetFlagsResponseError)

export const getFeatureFlagsControllerGetFlagsUrl = (params: FeatureFlagsControllerGetFlagsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/feature-flags?${stringifiedParams}` : `/feature-flags`
}

/**
 * Returns a map of flag keys to their enabled/disabled status for the specified partner. Flags that have no row default to disabled (not included in the response).
 * @summary Get all feature flags for a partner
 */
export const featureFlagsControllerGetFlags = async (params: FeatureFlagsControllerGetFlagsParams, options?: Parameters<typeof customFetch>[1]): Promise<featureFlagsControllerGetFlagsResponse> => {

  return customFetch<featureFlagsControllerGetFlagsResponse>(getFeatureFlagsControllerGetFlagsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFeatureFlagsControllerGetFlagsQueryKey = (params?: FeatureFlagsControllerGetFlagsParams,) => {
    return [
    `/feature-flags`, ...(params ? [params] : [])
    ] as const;
    }


export const getFeatureFlagsControllerGetFlagsQueryOptions = <TData = Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError = void>(params: FeatureFlagsControllerGetFlagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeatureFlagsControllerGetFlagsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>> = ({ signal }) => featureFlagsControllerGetFlags(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FeatureFlagsControllerGetFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>>
export type FeatureFlagsControllerGetFlagsQueryError = void


export function useFeatureFlagsControllerGetFlags<TData = Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError = void>(
 params: FeatureFlagsControllerGetFlagsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>,
          TError,
          Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeatureFlagsControllerGetFlags<TData = Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError = void>(
 params: FeatureFlagsControllerGetFlagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>,
          TError,
          Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeatureFlagsControllerGetFlags<TData = Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError = void>(
 params: FeatureFlagsControllerGetFlagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all feature flags for a partner
 */

export function useFeatureFlagsControllerGetFlags<TData = Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError = void>(
 params: FeatureFlagsControllerGetFlagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFeatureFlagsControllerGetFlagsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get all feature flags for a partner
 */
export const prefetchFeatureFlagsControllerGetFlagsQuery = async <TData = Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError = void>(
 queryClient: QueryClient, params: FeatureFlagsControllerGetFlagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getFeatureFlagsControllerGetFlagsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getFeatureFlagsControllerGetFlagsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError = void>(params: FeatureFlagsControllerGetFlagsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeatureFlagsControllerGetFlagsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>> = ({ signal }) => featureFlagsControllerGetFlags(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FeatureFlagsControllerGetFlagsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>>
export type FeatureFlagsControllerGetFlagsSuspenseQueryError = void


export function useFeatureFlagsControllerGetFlagsSuspense<TData = Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError = void>(
 params: FeatureFlagsControllerGetFlagsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeatureFlagsControllerGetFlagsSuspense<TData = Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError = void>(
 params: FeatureFlagsControllerGetFlagsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeatureFlagsControllerGetFlagsSuspense<TData = Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError = void>(
 params: FeatureFlagsControllerGetFlagsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all feature flags for a partner
 */

export function useFeatureFlagsControllerGetFlagsSuspense<TData = Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError = void>(
 params: FeatureFlagsControllerGetFlagsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFeatureFlagsControllerGetFlagsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type featureFlagsControllerListFlagsResponse200 = {
  data: FeatureFlagListItemDto[]
  status: 200
}

export type featureFlagsControllerListFlagsResponse401 = {
  data: void
  status: 401
}

export type featureFlagsControllerListFlagsResponse403 = {
  data: void
  status: 403
}

export type featureFlagsControllerListFlagsResponseSuccess = (featureFlagsControllerListFlagsResponse200) & {
  headers: Headers;
};
export type featureFlagsControllerListFlagsResponseError = (featureFlagsControllerListFlagsResponse401 | featureFlagsControllerListFlagsResponse403) & {
  headers: Headers;
};

export type featureFlagsControllerListFlagsResponse = (featureFlagsControllerListFlagsResponseSuccess | featureFlagsControllerListFlagsResponseError)

export const getFeatureFlagsControllerListFlagsUrl = () => {




  return `/feature-flags/admin`
}

/**
 * Returns all feature flags with the count of partners that have each flag enabled. Admin-only.
 * @summary List all feature flags (admin)
 */
export const featureFlagsControllerListFlags = async ( options?: Parameters<typeof customFetch>[1]): Promise<featureFlagsControllerListFlagsResponse> => {

  return customFetch<featureFlagsControllerListFlagsResponse>(getFeatureFlagsControllerListFlagsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFeatureFlagsControllerListFlagsQueryKey = () => {
    return [
    `/feature-flags/admin`
    ] as const;
    }


export const getFeatureFlagsControllerListFlagsQueryOptions = <TData = Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeatureFlagsControllerListFlagsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof featureFlagsControllerListFlags>>> = ({ signal }) => featureFlagsControllerListFlags({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FeatureFlagsControllerListFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof featureFlagsControllerListFlags>>>
export type FeatureFlagsControllerListFlagsQueryError = void


export function useFeatureFlagsControllerListFlags<TData = Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof featureFlagsControllerListFlags>>,
          TError,
          Awaited<ReturnType<typeof featureFlagsControllerListFlags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeatureFlagsControllerListFlags<TData = Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof featureFlagsControllerListFlags>>,
          TError,
          Awaited<ReturnType<typeof featureFlagsControllerListFlags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeatureFlagsControllerListFlags<TData = Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all feature flags (admin)
 */

export function useFeatureFlagsControllerListFlags<TData = Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFeatureFlagsControllerListFlagsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List all feature flags (admin)
 */
export const prefetchFeatureFlagsControllerListFlagsQuery = async <TData = Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError = void>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getFeatureFlagsControllerListFlagsQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getFeatureFlagsControllerListFlagsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError = void>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeatureFlagsControllerListFlagsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof featureFlagsControllerListFlags>>> = ({ signal }) => featureFlagsControllerListFlags({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FeatureFlagsControllerListFlagsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof featureFlagsControllerListFlags>>>
export type FeatureFlagsControllerListFlagsSuspenseQueryError = void


export function useFeatureFlagsControllerListFlagsSuspense<TData = Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError = void>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeatureFlagsControllerListFlagsSuspense<TData = Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError = void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeatureFlagsControllerListFlagsSuspense<TData = Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError = void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all feature flags (admin)
 */

export function useFeatureFlagsControllerListFlagsSuspense<TData = Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError = void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerListFlags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFeatureFlagsControllerListFlagsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type featureFlagsControllerCreateFlagResponse201 = {
  data: FeatureFlagDetailDto
  status: 201
}

export type featureFlagsControllerCreateFlagResponse401 = {
  data: void
  status: 401
}

export type featureFlagsControllerCreateFlagResponse403 = {
  data: void
  status: 403
}

export type featureFlagsControllerCreateFlagResponseSuccess = (featureFlagsControllerCreateFlagResponse201) & {
  headers: Headers;
};
export type featureFlagsControllerCreateFlagResponseError = (featureFlagsControllerCreateFlagResponse401 | featureFlagsControllerCreateFlagResponse403) & {
  headers: Headers;
};

export type featureFlagsControllerCreateFlagResponse = (featureFlagsControllerCreateFlagResponseSuccess | featureFlagsControllerCreateFlagResponseError)

export const getFeatureFlagsControllerCreateFlagUrl = () => {




  return `/feature-flags/admin`
}

/**
 * Creates a new feature flag with the given key and optional description. Admin-only.
 * @summary Create a feature flag (admin)
 */
export const featureFlagsControllerCreateFlag = async (createFeatureFlagDto: CreateFeatureFlagDto, options?: Parameters<typeof customFetch>[1]): Promise<featureFlagsControllerCreateFlagResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<featureFlagsControllerCreateFlagResponse>(getFeatureFlagsControllerCreateFlagUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createFeatureFlagDto)
  }
);}





export const getFeatureFlagsControllerCreateFlagMutationKey = () => ['featureFlagsControllerCreateFlag'] as const;

export const getFeatureFlagsControllerCreateFlagMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof featureFlagsControllerCreateFlag>>, TError,FeatureFlagsControllerCreateFlagMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof featureFlagsControllerCreateFlag>>, TError,FeatureFlagsControllerCreateFlagMutationVariables, TContext> => {

const mutationKey = getFeatureFlagsControllerCreateFlagMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof featureFlagsControllerCreateFlag>>, FeatureFlagsControllerCreateFlagMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  featureFlagsControllerCreateFlag(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FeatureFlagsControllerCreateFlagMutationResult = NonNullable<Awaited<ReturnType<typeof featureFlagsControllerCreateFlag>>>
    export type FeatureFlagsControllerCreateFlagMutationBody = CreateFeatureFlagDto
    export type FeatureFlagsControllerCreateFlagMutationError = void
    export type FeatureFlagsControllerCreateFlagMutationVariables = {data: CreateFeatureFlagDto}

    /**
 * @summary Create a feature flag (admin)
 */
export const useFeatureFlagsControllerCreateFlag = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof featureFlagsControllerCreateFlag>>, TError,FeatureFlagsControllerCreateFlagMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof featureFlagsControllerCreateFlag>>,
        TError,
        FeatureFlagsControllerCreateFlagMutationVariables,
        TContext
      > => {
      return useMutation(getFeatureFlagsControllerCreateFlagMutationOptions(options), queryClient);
    }
    export type featureFlagsControllerGetPartnerStatusesResponse200 = {
  data: FeatureFlagPartnerStatusDto[]
  status: 200
}

export type featureFlagsControllerGetPartnerStatusesResponse401 = {
  data: void
  status: 401
}

export type featureFlagsControllerGetPartnerStatusesResponse403 = {
  data: void
  status: 403
}

export type featureFlagsControllerGetPartnerStatusesResponse404 = {
  data: void
  status: 404
}

export type featureFlagsControllerGetPartnerStatusesResponseSuccess = (featureFlagsControllerGetPartnerStatusesResponse200) & {
  headers: Headers;
};
export type featureFlagsControllerGetPartnerStatusesResponseError = (featureFlagsControllerGetPartnerStatusesResponse401 | featureFlagsControllerGetPartnerStatusesResponse403 | featureFlagsControllerGetPartnerStatusesResponse404) & {
  headers: Headers;
};

export type featureFlagsControllerGetPartnerStatusesResponse = (featureFlagsControllerGetPartnerStatusesResponseSuccess | featureFlagsControllerGetPartnerStatusesResponseError)

export const getFeatureFlagsControllerGetPartnerStatusesUrl = (flagKey: string,) => {




  return `/feature-flags/admin/${flagKey}/partners`
}

/**
 * Returns all partners with their enabled/disabled status for the specified flag. Admin-only.
 * @summary Get partner statuses for a feature flag (admin)
 */
export const featureFlagsControllerGetPartnerStatuses = async (flagKey: string, options?: Parameters<typeof customFetch>[1]): Promise<featureFlagsControllerGetPartnerStatusesResponse> => {

  return customFetch<featureFlagsControllerGetPartnerStatusesResponse>(getFeatureFlagsControllerGetPartnerStatusesUrl(flagKey),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFeatureFlagsControllerGetPartnerStatusesQueryKey = (flagKey: string,) => {
    return [
    `/feature-flags/admin/${flagKey}/partners`
    ] as const;
    }


export const getFeatureFlagsControllerGetPartnerStatusesQueryOptions = <TData = Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError = void>(flagKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeatureFlagsControllerGetPartnerStatusesQueryKey(flagKey);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>> = ({ signal }) => featureFlagsControllerGetPartnerStatuses(flagKey, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: flagKey !== null && flagKey !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FeatureFlagsControllerGetPartnerStatusesQueryResult = NonNullable<Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>>
export type FeatureFlagsControllerGetPartnerStatusesQueryError = void


export function useFeatureFlagsControllerGetPartnerStatuses<TData = Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError = void>(
 flagKey: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>,
          TError,
          Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeatureFlagsControllerGetPartnerStatuses<TData = Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError = void>(
 flagKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>,
          TError,
          Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeatureFlagsControllerGetPartnerStatuses<TData = Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError = void>(
 flagKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get partner statuses for a feature flag (admin)
 */

export function useFeatureFlagsControllerGetPartnerStatuses<TData = Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError = void>(
 flagKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFeatureFlagsControllerGetPartnerStatusesQueryOptions(flagKey,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get partner statuses for a feature flag (admin)
 */
export const prefetchFeatureFlagsControllerGetPartnerStatusesQuery = async <TData = Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError = void>(
 queryClient: QueryClient, flagKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getFeatureFlagsControllerGetPartnerStatusesQueryOptions(flagKey,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getFeatureFlagsControllerGetPartnerStatusesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError = void>(flagKey: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeatureFlagsControllerGetPartnerStatusesQueryKey(flagKey);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>> = ({ signal }) => featureFlagsControllerGetPartnerStatuses(flagKey, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FeatureFlagsControllerGetPartnerStatusesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>>
export type FeatureFlagsControllerGetPartnerStatusesSuspenseQueryError = void


export function useFeatureFlagsControllerGetPartnerStatusesSuspense<TData = Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError = void>(
 flagKey: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeatureFlagsControllerGetPartnerStatusesSuspense<TData = Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError = void>(
 flagKey: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeatureFlagsControllerGetPartnerStatusesSuspense<TData = Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError = void>(
 flagKey: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get partner statuses for a feature flag (admin)
 */

export function useFeatureFlagsControllerGetPartnerStatusesSuspense<TData = Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError = void>(
 flagKey: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagsControllerGetPartnerStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFeatureFlagsControllerGetPartnerStatusesSuspenseQueryOptions(flagKey,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type featureFlagsControllerBulkSetPartnersResponse200 = {
  data: FeatureFlagPartnerStatusDto[]
  status: 200
}

export type featureFlagsControllerBulkSetPartnersResponse401 = {
  data: void
  status: 401
}

export type featureFlagsControllerBulkSetPartnersResponse403 = {
  data: void
  status: 403
}

export type featureFlagsControllerBulkSetPartnersResponse404 = {
  data: void
  status: 404
}

export type featureFlagsControllerBulkSetPartnersResponseSuccess = (featureFlagsControllerBulkSetPartnersResponse200) & {
  headers: Headers;
};
export type featureFlagsControllerBulkSetPartnersResponseError = (featureFlagsControllerBulkSetPartnersResponse401 | featureFlagsControllerBulkSetPartnersResponse403 | featureFlagsControllerBulkSetPartnersResponse404) & {
  headers: Headers;
};

export type featureFlagsControllerBulkSetPartnersResponse = (featureFlagsControllerBulkSetPartnersResponseSuccess | featureFlagsControllerBulkSetPartnersResponseError)

export const getFeatureFlagsControllerBulkSetPartnersUrl = (flagKey: string,) => {




  return `/feature-flags/admin/${flagKey}/partners`
}

/**
 * Upserts enabled/disabled status for one or more partners on a feature flag. Admin-only.
 * @summary Bulk set partner flag statuses (admin)
 */
export const featureFlagsControllerBulkSetPartners = async (flagKey: string,
    bulkSetPartnersDto: BulkSetPartnersDto, options?: Parameters<typeof customFetch>[1]): Promise<featureFlagsControllerBulkSetPartnersResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<featureFlagsControllerBulkSetPartnersResponse>(getFeatureFlagsControllerBulkSetPartnersUrl(flagKey),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkSetPartnersDto)
  }
);}





export const getFeatureFlagsControllerBulkSetPartnersMutationKey = () => ['featureFlagsControllerBulkSetPartners'] as const;

export const getFeatureFlagsControllerBulkSetPartnersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof featureFlagsControllerBulkSetPartners>>, TError,FeatureFlagsControllerBulkSetPartnersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof featureFlagsControllerBulkSetPartners>>, TError,FeatureFlagsControllerBulkSetPartnersMutationVariables, TContext> => {

const mutationKey = getFeatureFlagsControllerBulkSetPartnersMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof featureFlagsControllerBulkSetPartners>>, FeatureFlagsControllerBulkSetPartnersMutationVariables> = (props) => {
          const {flagKey,data} = props ?? {};

          return  featureFlagsControllerBulkSetPartners(flagKey,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FeatureFlagsControllerBulkSetPartnersMutationResult = NonNullable<Awaited<ReturnType<typeof featureFlagsControllerBulkSetPartners>>>
    export type FeatureFlagsControllerBulkSetPartnersMutationBody = BulkSetPartnersDto
    export type FeatureFlagsControllerBulkSetPartnersMutationError = void
    export type FeatureFlagsControllerBulkSetPartnersMutationVariables = {flagKey: string;data: BulkSetPartnersDto}

    /**
 * @summary Bulk set partner flag statuses (admin)
 */
export const useFeatureFlagsControllerBulkSetPartners = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof featureFlagsControllerBulkSetPartners>>, TError,FeatureFlagsControllerBulkSetPartnersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof featureFlagsControllerBulkSetPartners>>,
        TError,
        FeatureFlagsControllerBulkSetPartnersMutationVariables,
        TContext
      > => {
      return useMutation(getFeatureFlagsControllerBulkSetPartnersMutationOptions(options), queryClient);
    }
    export type featureFlagsControllerUpdateFlagResponse200 = {
  data: FeatureFlagDetailDto
  status: 200
}

export type featureFlagsControllerUpdateFlagResponse401 = {
  data: void
  status: 401
}

export type featureFlagsControllerUpdateFlagResponse403 = {
  data: void
  status: 403
}

export type featureFlagsControllerUpdateFlagResponse404 = {
  data: void
  status: 404
}

export type featureFlagsControllerUpdateFlagResponseSuccess = (featureFlagsControllerUpdateFlagResponse200) & {
  headers: Headers;
};
export type featureFlagsControllerUpdateFlagResponseError = (featureFlagsControllerUpdateFlagResponse401 | featureFlagsControllerUpdateFlagResponse403 | featureFlagsControllerUpdateFlagResponse404) & {
  headers: Headers;
};

export type featureFlagsControllerUpdateFlagResponse = (featureFlagsControllerUpdateFlagResponseSuccess | featureFlagsControllerUpdateFlagResponseError)

export const getFeatureFlagsControllerUpdateFlagUrl = (flagKey: string,) => {




  return `/feature-flags/admin/${flagKey}`
}

/**
 * Updates the description of an existing feature flag. Admin-only.
 * @summary Update a feature flag (admin)
 */
export const featureFlagsControllerUpdateFlag = async (flagKey: string,
    updateFeatureFlagDto: UpdateFeatureFlagDto, options?: Parameters<typeof customFetch>[1]): Promise<featureFlagsControllerUpdateFlagResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<featureFlagsControllerUpdateFlagResponse>(getFeatureFlagsControllerUpdateFlagUrl(flagKey),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateFeatureFlagDto)
  }
);}





export const getFeatureFlagsControllerUpdateFlagMutationKey = () => ['featureFlagsControllerUpdateFlag'] as const;

export const getFeatureFlagsControllerUpdateFlagMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof featureFlagsControllerUpdateFlag>>, TError,FeatureFlagsControllerUpdateFlagMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof featureFlagsControllerUpdateFlag>>, TError,FeatureFlagsControllerUpdateFlagMutationVariables, TContext> => {

const mutationKey = getFeatureFlagsControllerUpdateFlagMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof featureFlagsControllerUpdateFlag>>, FeatureFlagsControllerUpdateFlagMutationVariables> = (props) => {
          const {flagKey,data} = props ?? {};

          return  featureFlagsControllerUpdateFlag(flagKey,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FeatureFlagsControllerUpdateFlagMutationResult = NonNullable<Awaited<ReturnType<typeof featureFlagsControllerUpdateFlag>>>
    export type FeatureFlagsControllerUpdateFlagMutationBody = UpdateFeatureFlagDto
    export type FeatureFlagsControllerUpdateFlagMutationError = void
    export type FeatureFlagsControllerUpdateFlagMutationVariables = {flagKey: string;data: UpdateFeatureFlagDto}

    /**
 * @summary Update a feature flag (admin)
 */
export const useFeatureFlagsControllerUpdateFlag = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof featureFlagsControllerUpdateFlag>>, TError,FeatureFlagsControllerUpdateFlagMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof featureFlagsControllerUpdateFlag>>,
        TError,
        FeatureFlagsControllerUpdateFlagMutationVariables,
        TContext
      > => {
      return useMutation(getFeatureFlagsControllerUpdateFlagMutationOptions(options), queryClient);
    }
    export type featureFlagsControllerDeleteFlagResponse200 = {
  data: void
  status: 200
}

export type featureFlagsControllerDeleteFlagResponse401 = {
  data: void
  status: 401
}

export type featureFlagsControllerDeleteFlagResponse403 = {
  data: void
  status: 403
}

export type featureFlagsControllerDeleteFlagResponse404 = {
  data: void
  status: 404
}

export type featureFlagsControllerDeleteFlagResponseSuccess = (featureFlagsControllerDeleteFlagResponse200) & {
  headers: Headers;
};
export type featureFlagsControllerDeleteFlagResponseError = (featureFlagsControllerDeleteFlagResponse401 | featureFlagsControllerDeleteFlagResponse403 | featureFlagsControllerDeleteFlagResponse404) & {
  headers: Headers;
};

export type featureFlagsControllerDeleteFlagResponse = (featureFlagsControllerDeleteFlagResponseSuccess | featureFlagsControllerDeleteFlagResponseError)

export const getFeatureFlagsControllerDeleteFlagUrl = (flagKey: string,) => {




  return `/feature-flags/admin/${flagKey}`
}

/**
 * Deletes a feature flag and all its partner associations (cascade). Admin-only.
 * @summary Delete a feature flag (admin)
 */
export const featureFlagsControllerDeleteFlag = async (flagKey: string, options?: Parameters<typeof customFetch>[1]): Promise<featureFlagsControllerDeleteFlagResponse> => {

  return customFetch<featureFlagsControllerDeleteFlagResponse>(getFeatureFlagsControllerDeleteFlagUrl(flagKey),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getFeatureFlagsControllerDeleteFlagMutationKey = () => ['featureFlagsControllerDeleteFlag'] as const;

export const getFeatureFlagsControllerDeleteFlagMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof featureFlagsControllerDeleteFlag>>, TError,FeatureFlagsControllerDeleteFlagMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof featureFlagsControllerDeleteFlag>>, TError,FeatureFlagsControllerDeleteFlagMutationVariables, TContext> => {

const mutationKey = getFeatureFlagsControllerDeleteFlagMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof featureFlagsControllerDeleteFlag>>, FeatureFlagsControllerDeleteFlagMutationVariables> = (props) => {
          const {flagKey} = props ?? {};

          return  featureFlagsControllerDeleteFlag(flagKey,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FeatureFlagsControllerDeleteFlagMutationResult = NonNullable<Awaited<ReturnType<typeof featureFlagsControllerDeleteFlag>>>

    export type FeatureFlagsControllerDeleteFlagMutationError = void
    export type FeatureFlagsControllerDeleteFlagMutationVariables = {flagKey: string}

    /**
 * @summary Delete a feature flag (admin)
 */
export const useFeatureFlagsControllerDeleteFlag = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof featureFlagsControllerDeleteFlag>>, TError,FeatureFlagsControllerDeleteFlagMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof featureFlagsControllerDeleteFlag>>,
        TError,
        FeatureFlagsControllerDeleteFlagMutationVariables,
        TContext
      > => {
      return useMutation(getFeatureFlagsControllerDeleteFlagMutationOptions(options), queryClient);
    }
